import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "inline-flex",
  role: "group"
}

import '../calcolatriceMedica.css'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'BaseButtons',
  props: {
    hiddenCancellaButton: Boolean,
    hiddenCalcolaButton: Boolean,
    hiddenSalvaButton: Boolean,
  },
  emits: ["clearForm", "calculate", "saveResult"],
  setup(__props, { emit }) {

const props = __props;

  

  

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("button", {
      type: "button",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('clearForm'))),
      class: "btnBase"
    }, _toDisplayString(_ctx.$t('Cancella')), 513), [
      [_vShow, !__props.hiddenCancellaButton]
    ]),
    _withDirectives(_createElementVNode("button", {
      type: "button",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('calculate'))),
      class: "btnBase"
    }, _toDisplayString(_ctx.$t('Calcola')), 513), [
      [_vShow, !__props.hiddenCalcolaButton]
    ]),
    _withDirectives(_createElementVNode("button", {
      type: "button",
      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('saveResult'))),
      class: "btnBase"
    }, _toDisplayString(_ctx.$t('Salva Punteggio')), 513), [
      [_vShow, !__props.hiddenSalvaButton]
    ])
  ]))
}
}

})